<template>
    <section>
            <div class="container">
                <div class="section-quote-bx">
                        <div class="quote-logo">
                            <a href="https://buildxact.com/" title="Open Buildxact in a new window or tab" target="_blank">
                                <img  :src="logo">
                            </a>
                        </div>
                        <div class="quote-title"><strong>Respond to quote requests better using Buildxact:</strong></div>
                        <ul>
                            <li>Track all your quote requests in one place from other Buildxact users</li>
                            <li>Integrate your pricing catalogues so Builders receive live updates</li>
                            <li>Generate your own quote requests to other suppliers</li>
                        </ul>
                        <div class="columns">
                            <div class="column"></div>
                            <div class="column">
                                <button type="button" @click="showQuoteInBX=false;" class="btn-invite  btn-invite--secondary">No, open here</button>
                            </div>
                            <div class="column">
                                <button type="button" @click="redirectToBX()" class="btn-invite" >Open now, for free</button>
                            </div>
                        </div>
                </div>
            </div>
    </section>
</template>

<script>

import logo from '@/assets/logo_150px_grey.png'

export default {
  name: 'section-quote-in-bx',
  components: {},
  props: [],
  data () {
    return {
      logo
    }
  },
  methods: {
    redirectToBX () {
      window.location.href = this.quoteUrlInBX
    }
  },
  computed: {
    showQuoteInBX: {
      get: function () {
        if (this.$store.state) {
          return this.$store.state.showQuoteInBX
        } else {
          return false
        }
      },
      set: function (newVal) {
        this.$store.commit('updateShowQuoteInBX', newVal)
      }
    },
    quoteUrlInBX: {
      get: function () {
        if (this.$store.state) {
          return this.$store.state.data.quoteUrlInBX
        } else {
          return null
        }
      }
    }
  }
}
</script>
